// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"596":"5ea74b6fc173b5fc3e13","651":"caafb113daabc64ef007"}[chunkId] + ".css";
};